import { render } from "./Program.vue?vue&type=template&id=958f32ce&scoped=true&ts=true"
import script from "./Program.vue?vue&type=script&lang=ts"
export * from "./Program.vue?vue&type=script&lang=ts"

import "./Program.vue?vue&type=style&index=0&id=958f32ce&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958f32ce"]])

export default __exports__